<template>
  <div class="project-team">
    <el-table :data="projectData" style="width: 100%" v-loading="loading">
      <el-table-column prop="number" label="项目编号" width="120px">
      </el-table-column>
      <el-table-column label="项目名称" width="200px">
        <template slot-scope="scope">
          <span v-if="scope.row.level==1" class="title-z">子项目</span>
          <router-link class="table-link" target="_blank" :to="'/Project/Detail/' + scope.row.id">{{scope.row.name}}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column prop="status" label="项目状态">
      </el-table-column>
      <el-table-column prop="leader.name" label="项目负责人">
      </el-table-column>
      <el-table-column prop="leader.mobile" label="联系方式">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Project/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['contractId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        projectData: [],
        // fatherData: [],
      }
    },
    mounted() {
      // 获取列表
      this.getLists()
    },
    components: {},
    methods: {
      projectDetail(row) {
        console.log(row.id)
        this.$router.push("/Project/Detail/" + row.id)
      },
      // 获取列表
      getLists() {
        ajax.get('/contract/relate/project/' + this.contractId, '', (res) => {
          this.loading = false
          this.projectData = res.vo.array
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/contract/projectlist.vue